// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AZ0WsWtweVcf33K4 {
    color: var(--lok-color-text-light-default);
}

.tYNlVX5Y2cp1jPe6 {
    font: var(--lok-typography-body-small-default);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    margin-right: var(--lok-spacing-1);
    max-width: 90%;

    & > * {
        white-space: nowrap;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/features/project/components/ProjectNavigationPanel/components/Breadcrumbs/Breadcrums.module.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;AAC9C;;AAEA;IACI,8CAA8C;;IAE9C,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;;IAEvB,kCAAkC;IAClC,cAAc;;IAEd;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".breadcrumbsItem {\n    color: var(--lok-color-text-light-default);\n}\n\n.breadcrumbs {\n    font: var(--lok-typography-body-small-default);\n\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    margin-right: var(--lok-spacing-1);\n    max-width: 90%;\n\n    & > * {\n        white-space: nowrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbsItem": `AZ0WsWtweVcf33K4`,
	"breadcrumbs": `tYNlVX5Y2cp1jPe6`
};
export default ___CSS_LOADER_EXPORT___;
